import { ConditionalRuleResponseModel } from "./conditional-rule-response.model";
import { ItemSelectResponseModel } from "./item-select-response.model";

export class ColumnResponseModel {
  label: string = "";
  propertyName: string = "";
  inputType: string = "";
  align: string = "";
  isFilter: boolean = false;
  valueFilter: any;
  valueAlterFilter: any;
  enpointColumnsModal: string = "";
  enpointDataModal: string = "";
  itemsSelect: ItemSelectResponseModel[] = [];
  conditionalRules: ConditionalRuleResponseModel[] = [];
}